module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light Italic TH.d38dbceb.woff";